export default "__VITE_ASSET__lBnegYWO__"